import React, { useEffect, useState } from 'react';

function formatAgo(ms) {
  const sec = Math.max(0, Math.round(ms / 1000));
  if (sec < 30) return 'just now';
  if (sec < 60) return `${sec}s ago`;
  const min = Math.floor(sec / 60);
  if (min < 60) return `${min}m ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr}h ago`;
  const day = Math.floor(hr / 24);
  return `${day}d ago`;
}

export default function SyncTimestamp({ fetchedAt }) {
  const fetchedMs = fetchedAt ? new Date(fetchedAt).getTime() : null;
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (!fetchedMs) return;
    const id = setInterval(() => setNow(Date.now()), 15000);
    return () => clearInterval(id);
  }, [fetchedMs]);

  if (!fetchedMs || Number.isNaN(fetchedMs)) return null;

  const label = formatAgo(now - fetchedMs);
  const absolute = new Date(fetchedMs).toLocaleString();

  return (
    <span
      title={`Last sync: ${absolute}`}
      className="inline-flex items-center gap-1.5 text-[11.5px]"
      style={{ color: '#9A9A95' }}
    >
      <span
        aria-hidden="true"
        style={{
          width: 6, height: 6, borderRadius: '50%',
          background: '#1F6B41', display: 'inline-block'
        }}
      />
      Synced from <span style={{ color: '#3A3A38' }}>Redmine</span> · {label}
    </span>
  );
}
